import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type UpsertMySqlTenantIntegrationMutationVariables = Types.Exact<{
  input: Types.UpsertMySqlTenantIntegrationInput;
}>;


export type UpsertMySqlTenantIntegrationMutation = { __typename?: 'Mutation', upsertMySqlTenantIntegration: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteTenantIntegrationMutationVariables = Types.Exact<{
  input: Types.DeleteTenantIntegrationInput;
}>;


export type DeleteTenantIntegrationMutation = { __typename?: 'Mutation', deleteTenantIntegration: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpsertMergeTenantIntegrationMutationVariables = Types.Exact<{
  input: Types.UpsertMergeTenantIntegrationInput;
}>;


export type UpsertMergeTenantIntegrationMutation = { __typename?: 'Mutation', upsertMergeTenantIntegration: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpsertMergeCrmTenantIntegrationMutationVariables = Types.Exact<{
  input: Types.UpsertMergeCrmTenantIntegrationInput;
}>;


export type UpsertMergeCrmTenantIntegrationMutation = { __typename?: 'Mutation', upsertMergeCrmTenantIntegration: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MergeLinkTokenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MergeLinkTokenMutation = { __typename?: 'Mutation', mergeLinkToken: { __typename?: 'MergeLinkTokenPayload', linkToken?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteMergeLinkMutationVariables = Types.Exact<{
  input: Types.CompleteMergeLinkInput;
}>;


export type CompleteMergeLinkMutation = { __typename?: 'Mutation', completeMergeLink: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReconnectMergeLinkMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ReconnectMergeLinkInput>;
}>;


export type ReconnectMergeLinkMutation = { __typename?: 'Mutation', reconnectMergeLink: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteGrowPointIterationsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteGrowPointIterationsMutation = { __typename?: 'Mutation', deleteGrowPointIterations: { __typename?: 'DeleteGrowPointIterationsResultData', deletedCount: number } };

export type SetAccountingIntegrationConfigMutationVariables = Types.Exact<{
  input: Types.SetAccountingIntegrationConfigInput;
}>;


export type SetAccountingIntegrationConfigMutation = { __typename?: 'Mutation', setAccountingIntegrationConfig: { __typename?: 'AccountingIntegrationConfigPayload', accountingIntegrationConfig?: { __typename?: 'AccountingIntegrationConfigStateData', provider: Types.AccountingProvider, mergeDevAccountId?: string | null, outboundDetail: Types.OutboundDetailLevel, oneTimePullCompleted: boolean, oneTimePullCompletedAt?: Types.TDateISO | null, defaultIncomeAccount?: { __typename?: 'DefaultIncomeAccount', accountRemoteId: string, accountName: string, accountImportId: string } | null, defaultIncomeAccountJoined?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetAccountingLineAccountsMutationVariables = Types.Exact<{
  input: Types.SetAccountingLineAccountsInput;
}>;


export type SetAccountingLineAccountsMutation = { __typename?: 'Mutation', setAccountingLineAccounts: { __typename?: 'AccountingIntegrationConfigPayload', accountingIntegrationConfig?: { __typename?: 'AccountingIntegrationConfigStateData', salesTaxAccountId?: string | null, fuelSurchargeAccountId?: string | null, freightAccountId?: string | null, depositAppliedAccountId?: string | null, roundingAdjustmentAccountId?: string | null, salesTaxAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, fuelSurchargeAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, freightAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, depositAppliedAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null, roundingAdjustmentAccount?: { __typename?: 'MergeDevAccountDocument', importId: string, name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConnectOrderEaseIntegrationMutationVariables = Types.Exact<{
  input: Types.ConnectOrderEaseIntegrationInput;
}>;


export type ConnectOrderEaseIntegrationMutation = { __typename?: 'Mutation', connectOrderEaseIntegration: { __typename?: 'OrderEaseConnectionPayload', integration?: { __typename?: 'OrderEaseConnectionStatus', connected: boolean, connectedAt?: Types.TDateISO | null, maskedClientKey?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DisconnectOrderEaseIntegrationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DisconnectOrderEaseIntegrationMutation = { __typename?: 'Mutation', disconnectOrderEaseIntegration: { __typename?: 'OrderEaseConnectionPayload', integration?: { __typename?: 'OrderEaseConnectionStatus', connected: boolean, connectedAt?: Types.TDateISO | null, maskedClientKey?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const UpsertMySqlTenantIntegrationDocument = new TypedDocumentString(`
    mutation UpsertMySqlTenantIntegration($input: UpsertMySqlTenantIntegrationInput!) {
  upsertMySqlTenantIntegration(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const DeleteTenantIntegrationDocument = new TypedDocumentString(`
    mutation DeleteTenantIntegration($input: DeleteTenantIntegrationInput!) {
  deleteTenantIntegration(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpsertMergeTenantIntegrationDocument = new TypedDocumentString(`
    mutation UpsertMergeTenantIntegration($input: UpsertMergeTenantIntegrationInput!) {
  upsertMergeTenantIntegration(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpsertMergeCrmTenantIntegrationDocument = new TypedDocumentString(`
    mutation UpsertMergeCrmTenantIntegration($input: UpsertMergeCrmTenantIntegrationInput!) {
  upsertMergeCrmTenantIntegration(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const MergeLinkTokenDocument = new TypedDocumentString(`
    mutation MergeLinkToken {
  mergeLinkToken {
    linkToken
    errors {
      code
      message
    }
  }
}
    `);
export const CompleteMergeLinkDocument = new TypedDocumentString(`
    mutation CompleteMergeLink($input: CompleteMergeLinkInput!) {
  completeMergeLink(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const ReconnectMergeLinkDocument = new TypedDocumentString(`
    mutation ReconnectMergeLink($input: ReconnectMergeLinkInput) {
  reconnectMergeLink(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const DeleteGrowPointIterationsDocument = new TypedDocumentString(`
    mutation DeleteGrowPointIterations {
  deleteGrowPointIterations {
    deletedCount
  }
}
    `);
export const SetAccountingIntegrationConfigDocument = new TypedDocumentString(`
    mutation SetAccountingIntegrationConfig($input: SetAccountingIntegrationConfigInput!) {
  setAccountingIntegrationConfig(input: $input) {
    accountingIntegrationConfig {
      provider
      mergeDevAccountId
      outboundDetail
      defaultIncomeAccount {
        accountRemoteId
        accountName
        accountImportId
      }
      defaultIncomeAccountJoined {
        ...JoinedGlAccount
      }
      oneTimePullCompleted
      oneTimePullCompletedAt
    }
    errors {
      code
      message
    }
  }
}
    fragment JoinedGlAccount on MergeDevAccountDocument {
  importId
  name
  accountNumber
  status
}`);
export const SetAccountingLineAccountsDocument = new TypedDocumentString(`
    mutation SetAccountingLineAccounts($input: SetAccountingLineAccountsInput!) {
  setAccountingLineAccounts(input: $input) {
    accountingIntegrationConfig {
      salesTaxAccountId
      salesTaxAccount {
        ...JoinedGlAccount
      }
      fuelSurchargeAccountId
      fuelSurchargeAccount {
        ...JoinedGlAccount
      }
      freightAccountId
      freightAccount {
        ...JoinedGlAccount
      }
      depositAppliedAccountId
      depositAppliedAccount {
        ...JoinedGlAccount
      }
      roundingAdjustmentAccountId
      roundingAdjustmentAccount {
        ...JoinedGlAccount
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment JoinedGlAccount on MergeDevAccountDocument {
  importId
  name
  accountNumber
  status
}`);
export const ConnectOrderEaseIntegrationDocument = new TypedDocumentString(`
    mutation ConnectOrderEaseIntegration($input: ConnectOrderEaseIntegrationInput!) {
  connectOrderEaseIntegration(input: $input) {
    integration {
      ...OrderEaseConnectionStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderEaseConnectionStatusFields on OrderEaseConnectionStatus {
  connected
  connectedAt
  maskedClientKey
}`);
export const DisconnectOrderEaseIntegrationDocument = new TypedDocumentString(`
    mutation DisconnectOrderEaseIntegration {
  disconnectOrderEaseIntegration {
    integration {
      ...OrderEaseConnectionStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment OrderEaseConnectionStatusFields on OrderEaseConnectionStatus {
  connected
  connectedAt
  maskedClientKey
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    UpsertMySqlTenantIntegration: build.mutation<UpsertMySqlTenantIntegrationMutation, UpsertMySqlTenantIntegrationMutationVariables>({
      query: (variables) => ({ document: UpsertMySqlTenantIntegrationDocument, variables })
    }),
    DeleteTenantIntegration: build.mutation<DeleteTenantIntegrationMutation, DeleteTenantIntegrationMutationVariables>({
      query: (variables) => ({ document: DeleteTenantIntegrationDocument, variables })
    }),
    UpsertMergeTenantIntegration: build.mutation<UpsertMergeTenantIntegrationMutation, UpsertMergeTenantIntegrationMutationVariables>({
      query: (variables) => ({ document: UpsertMergeTenantIntegrationDocument, variables })
    }),
    UpsertMergeCrmTenantIntegration: build.mutation<UpsertMergeCrmTenantIntegrationMutation, UpsertMergeCrmTenantIntegrationMutationVariables>({
      query: (variables) => ({ document: UpsertMergeCrmTenantIntegrationDocument, variables })
    }),
    MergeLinkToken: build.mutation<MergeLinkTokenMutation, MergeLinkTokenMutationVariables | void>({
      query: (variables) => ({ document: MergeLinkTokenDocument, variables })
    }),
    CompleteMergeLink: build.mutation<CompleteMergeLinkMutation, CompleteMergeLinkMutationVariables>({
      query: (variables) => ({ document: CompleteMergeLinkDocument, variables })
    }),
    ReconnectMergeLink: build.mutation<ReconnectMergeLinkMutation, ReconnectMergeLinkMutationVariables | void>({
      query: (variables) => ({ document: ReconnectMergeLinkDocument, variables })
    }),
    DeleteGrowPointIterations: build.mutation<DeleteGrowPointIterationsMutation, DeleteGrowPointIterationsMutationVariables | void>({
      query: (variables) => ({ document: DeleteGrowPointIterationsDocument, variables })
    }),
    SetAccountingIntegrationConfig: build.mutation<SetAccountingIntegrationConfigMutation, SetAccountingIntegrationConfigMutationVariables>({
      query: (variables) => ({ document: SetAccountingIntegrationConfigDocument, variables })
    }),
    SetAccountingLineAccounts: build.mutation<SetAccountingLineAccountsMutation, SetAccountingLineAccountsMutationVariables>({
      query: (variables) => ({ document: SetAccountingLineAccountsDocument, variables })
    }),
    ConnectOrderEaseIntegration: build.mutation<ConnectOrderEaseIntegrationMutation, ConnectOrderEaseIntegrationMutationVariables>({
      query: (variables) => ({ document: ConnectOrderEaseIntegrationDocument, variables })
    }),
    DisconnectOrderEaseIntegration: build.mutation<DisconnectOrderEaseIntegrationMutation, DisconnectOrderEaseIntegrationMutationVariables | void>({
      query: (variables) => ({ document: DisconnectOrderEaseIntegrationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useUpsertMySqlTenantIntegrationMutation, useDeleteTenantIntegrationMutation, useUpsertMergeTenantIntegrationMutation, useUpsertMergeCrmTenantIntegrationMutation, useMergeLinkTokenMutation, useCompleteMergeLinkMutation, useReconnectMergeLinkMutation, useDeleteGrowPointIterationsMutation, useSetAccountingIntegrationConfigMutation, useSetAccountingLineAccountsMutation, useConnectOrderEaseIntegrationMutation, useDisconnectOrderEaseIntegrationMutation } = injectedRtkApi;
